export default class Toast {
    constructor(uuid, component, props, context, timeout) {
        this.props = props;
        this.uuid = uuid;
        this.component = component;
        this.context = context;
        this.timeout = timeout;
    }
}
